import { useRootStore } from 'stores/RootStore'

/**
 * BLZ-14761: any Pioneer-era workspace that has either trialed and converted
 * (now active or cancelled) OR trialed and never converted (cancelled with
 * trial_ended === true) should be routed to the current Starter/Growth modal,
 * not the legacy Pioneer-only one. Previously this hook gated reactivation on
 * `!trial_ended`, which left expired-trial workspaces on Pioneer pricing.
 */
export const useIsActiveOrCanceledPioneerPlan = () => {
  const { currentSubscription } = useRootStore().tierUsageStore

  const isCanceledOrActivePioneerPlan =
    currentSubscription?.status === 'active' || currentSubscription?.status === 'canceled'

  return isCanceledOrActivePioneerPlan
}
